import { Typography, capitalize, styled } from "@mui/material";
import { actionHeaderName } from "../classes.js";
const Title = styled(Typography, {
  name: actionHeaderName,
  slot: "Title",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [
      styles.title,
      ownerState?.size && styles[`titleSize${capitalize(ownerState.size)}`],
      ownerState?.titleClickable && "titleClickable"
    ];
  }
})(({ theme, ownerState }) => {
  const large = ownerState?.size === "large";
  const smallish = ownerState?.size === "tiny" || ownerState?.size === "small";
  const leftMargin = large ? 1.5 : smallish ? 0.5 : 1;
  return {
    fontWeight: 500,
    userSelect: "none",
    fontSize: "inherit",
    marginRight: theme.spacing(0.5),
    ...ownerState?.hideIcon && {
      marginLeft: theme.spacing(leftMargin)
    },
    ...ownerState?.titleClickable && {
      cursor: "pointer"
    }
  };
});
export {
  Title
};
//# sourceMappingURL=Title.js.map
